import React, { useEffect, useState } from 'react'

//COMPONENTS
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ErrorAlert from '../../../Alerts/ErrorAlert';
import LoadingAlert from '../../../Alerts/LoadingAlert';
import ConfirmationAlert from '../../../Alerts/ConfirmationAlert';
import ModalClientProfile from '../../../PaymentPost/ModalClientProfile';
import ModalCreateNewClient from '../../../PaymentPost/ModalCreateNewClient';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

//APIS
import { PrinterFetchAPI } from '../../../../api/Printer';
import { MachinesFetchAPI } from '../../../../api/Machines';
import { AuthDgiFetchAPI } from '../../../../api/Paymentpost/AuthDgi';
import { PreOrderFetchAPI } from '../../../../api/Paymentpost/PreOrder';
import { CategriesPosFetchAPI } from '../../../../api/Paymentpost/CategoriesPos';
import { RequestLocalFetchAPI } from '../../../../api/Paymentpost/RequestLocal';
import { MailFetchAPI } from '../../../../api/Mail';
import { WhatsappFetchAPI } from '../../../../api/Whatsapp';
import printOrderData from '../../../PaymentPost/PrintOrderData';
import ModalSendLinkPayment from '../ModalSendLinkPayment';
//utils
import { buildCloudinaryImageUrl } from '../../../../utils/CloudinaryImageUrl';
//IMG
import defaultImage from "../../../../components/img/backgrounds/bgregis2.png";

import payOnline from "../../../PaymentPost/img/Payonline.png"
import './OrderOnlineModal.css'
function ModalCallCenter({ checkDeliveryOrder, dv, name, ruc, setDv, setName, setRuc, dataResponse, optionalData, setDataResponse, setOptionalData, shoppingCart, shoppingCartCombos, total, subtotal, tax, discount, setPageLoader, dataPreOrder, taxesArrayAll, cardGroup, dataDicountApply, paramsMicros, parthner_order, dataClientSelected, setdataClientSelected, addressNowLocation, setAddressNowLocation, domain, events }) {
   const [show, setShow] = useState(false);
   const [infoPrinter, setInfoPrinter] = useState({ printer_comanda: "", printer_ticket: "", printer_ip: "" })
   const [printers, setPrinters] = useState([]);
   const [dataOrder, setDataOrder] = useState({});
   const [tableNumber, setTableNumber] = useState(0);
   const [stateRequest, setStateRequest] = useState(false)
   const [sendLinkPayment, setSendLinkPayment] = useState(false)
   const [emailSendLink, setEmailSendLink] = useState("");
   const [phoneSendLink, setPhoneSendLink] = useState("");
   const [key, setKey] = useState('email');
   const [PreOrderDataCallCenter, setPreOrderDataCallCenter] = useState("");

   let title_modal = "Crear precuenta"
   let machine = JSON.parse(localStorage.getItem('machine'));
   let user = JSON.parse(localStorage.getItem('user'));
   let date = new Date().toJSON().slice(0, 10)

   const [selectedEvent, setSelectedEvent] = React.useState(null);
   const eventsAndDates = () => {
      return (<>
         {events.length > 0 &&
            <Form.Group className="mb-3">
               <span className='p-0  text-primary fw-bold'>Eventos </span>
               <Form.Select
                  className='mt-1'
                  value={selectedEvent ? selectedEvent.id : ''}
                  onChange={e => {
                     const eventObj = events.find(ev => String(ev.id) === String(e.target.value));
                     setSelectedEvent(eventObj);
                  }}
               >
                  <option value={null}>Selecciona un evento</option>
                  {(events || [])
                     .map(ev => (
                        <option key={ev.id} value={ev.id}>
                           {ev.name}
                        </option>
                     ))}
               </Form.Select>
            </Form.Group>
         }
      </>)
   }

   const getPreOrderByid = async () => {
      let machine_token = localStorage.getItem('x-access-machine-token');
      if (dataPreOrder.pre_Order == true) {
         try {
            const response = await PreOrderFetchAPI.getPreOrderById(dataPreOrder._id, machine_token);
            setDataOrder(response.data.pre_order)
            setTableNumber(response.data.pre_order.table_name);
         } catch (err) {
            console.log(err);
         }
      }
   }


   //function to authentication of ruc
   const authenticationDgi = async () => {
      let message = ""
      let title = ""
      let icon = ""
      if (ruc == "") {
         message = "No se ha ingresado ningun ruc."
         title = "Debes ingresar un ruc."
         icon = "warning"
         ErrorAlert(message, title, icon)
      } else {
         LoadingAlert()
         let token = localStorage.getItem('x-access-machine-token');
         let data = { ruc: ruc }
         try {
            const response = await AuthDgiFetchAPI.authenticationRuc(token, data)
            let dataDgi = response.data
            if (dataDgi.dgi_response.gResProc) {
               if (dataDgi.dgi_response.gResProc.dCodRes == "0680") {
                  let dvDgi = dataDgi.dgi_response.dDV
                  if (dvDgi.length < 2) { dvDgi = "0" + dvDgi }
                  setName(dataDgi.dgi_response.dNomb)
                  setDv(dvDgi)
                  message = "Datos del clientes obtenidos por la DGI"
                  title = "Datos obtenido correctamente"
                  icon = "success"
                  ErrorAlert(message, title, icon)
                  setDataResponse(true)
               } else {
                  setOptionalData(true)
                  message = "Ingrese los datos manualmente."
                  title = "Datos no encontrados"
                  icon = "warning"
                  ErrorAlert(message, title, icon)
               }
            }
         } catch (err) {
            console.log(err);
            setOptionalData(true)
            message = "Ingrese los datos manualmente."
            title = "Datos no encontrados"
            icon = "warning"
            ErrorAlert(message, title, icon)
         }
      }
   }

   const handlercreateValidation = () => {

      if (paramsMicros != 0) {
         console.log(paramsMicros)
         if (paramsMicros.pos_integration_id == 2) {
            formatDataMicrosCheck(shoppingCart, shoppingCartCombos, "create")
         } else {
            createPreOrder()
         }
      } else {
         createPreOrder()
      }
   }


   const handlerUpdateValidation = () => {
      if (paramsMicros != 0) {
         if (paramsMicros.pos_integration_id == 2) {
            handlerComparativeNewData()
         } else {
            updatePreOrder()
         }
      } else {
         updatePreOrder()
      }
   }

   //create preOrder
   const createPreOrder = async (micros) => {
      if (stateRequest == false) {
         setStateRequest(true)
         if ((shoppingCart.length + shoppingCartCombos.length) > 0) {
            LoadingAlert()
            let token = localStorage.getItem('x-access-machine-token');
            let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
            let machine = JSON.parse(localStorage.getItem('machine'))

            //console.log(shoppingCart);
            let json = {
               "client_name": name,
               "localizador": "00",
               "table_name": tableNumber,
               "client_phone": "0",
               "ruc": ruc,
               "dv": dv,
               "id_Client": 0,
               "dgi_qr": "0",
               "Orden": shoppingCart,
               "combos": shoppingCartCombos,
               "Descuento": discount,
               "Total": total,
               "itbms": tax,
               "subtotal": subtotal,
               "machine_id": machine.id,
               "branchoffice_id": branchoffice.id,
               "tipoOrden": checkDeliveryOrder,
               "paymethod": 0,
               "discounts": dataDicountApply,
               "is_discount_notification": false,
               "is_cupon": false,
               "is_authorized": true,
               "ecommerce_order": true,
               "is_devolution_notification": false,
               "taxes": taxesArrayAll,
               "is_pre_order": true, "user": {
                  id: user.id,
                  name: user.name,
                  code: user.user_code
               }
            }

            let eventData = localStorage.getItem('event');
            if (eventData !== null && eventData !== undefined && eventData !== "") {
               let eventDataState = JSON.parse(eventData);
               json.event_id = eventDataState.id
               json.event_name = eventDataState.name;
            }

            if (events.length > 0 && selectedEvent != null) {
               json.event_id = selectedEvent.id
            }

            if (addressNowLocation !== null) {
               console.log(addressNowLocation);
               json.direction = {
                  id: addressNowLocation.id,
                  lng: addressNowLocation.lng,
                  lat: addressNowLocation.lat
               };
            }
            if (dataClientSelected != null && dataClientSelected.id != undefined && dataClientSelected.id != null) {
               //json.id_client = dataClientSelected.id;
               json.client_id = dataClientSelected.id;
               console.log("se agrego el cliente", dataClientSelected);

            } else {
               console.log("No habia cliente", dataClientSelected);
            }
            if (micros != undefined) { json.micros_reference = micros.micros_reference }


            try {
               const response = await PreOrderFetchAPI.createPreOrder(json, token)
               setStateRequest(false)
               printOrder(response.data.newTempOrder._id, response.data.newTempOrder.code)
               setPreOrderDataCallCenter(response.data.newTempOrder)
               setShow(false)
               let message = "Precuenta creada con exito."
               let title = "Operacion exitosa."
               let icon = "success"
               ErrorAlert(message, title, icon)
               //setPageLoader(1)

               setSendLinkPayment(true)


            } catch (err) {
               setStateRequest(false)
               console.log(err);
            }
         } else {
            setStateRequest(false)
            ErrorAlert("Debes agregar  algo al carrito", "No hay productos en el carrito", "info")
         }

      } else {
         console.log("Ya se esta procesando la orden");
      }
   }



   //format data to send to micros
   const formatDataMicrosCheck = (groups, combos, action) => {
      //Json general format
      let jsonMicrosCheck = {
         RvcRef: paramsMicros.pos_integration_params.RvcRef,
         employeeNum: paramsMicros.pos_integration_params.employeeNum,
         host_url: paramsMicros.pos_integration_params.host_url,
         localMicrosServerIp: paramsMicros.pos_integration_params.localMicrosServerIp,
         products: [],
         automatic_payment: 0,
         delivery: false,
         client: { name: name, phone: "00" },
         paymentmethods: [{
            "name": "Credito",
            "paymenthod_id": 10,
            "total": total
         }],
      }

      if (action == "update") {
         let preOrderOld = JSON.parse(localStorage.getItem('preOrderComparativeOld'))
         jsonMicrosCheck.checkSeq = preOrderOld.micros_reference.checkSeq
         jsonMicrosCheck.checkNum = preOrderOld.micros_reference.checkNum
      }

      let data = []
      //json product format
      groups.forEach(product => {
         let dataDetail = {
            "code": product.group_id,
            "name": product.name,
            "price": product.price,
            "cant": product.amount,
            "tax": product.taxes[0].tax,
            "total_discount": product.discount,
            "exist_product": false,
            "total_product": product.price,
            "external_reference": product.external_reference,
            "type": "product",

         }

         let dataSegments = []
         //console.log("DATA SEGMENTS");
         //console.log(product);
         product.segments.forEach(segment => {
            let detail = {
               "external_reference": segment.external_reference,
               "name": segment.name,
               "amount": segment.amount,
            }
            dataSegments.push(detail)
         })
         dataDetail.condiments = dataSegments
         data.push(dataDetail)
      });

      //----------------------------------------------
      //format combos
      combos.forEach(combo => {

         //console.log(combo);
         let dataDetailCombo = {
            "type": "combo",
            "code": combo.combo_id,
            "tax": combo.taxes[0].tax,
            "total_discount": combo.discount,
            "exist_product": false,
            "total_product": combo.price,
            "external_reference": combo.referenced_group.external_reference,
            "price": combo.price,
            "name": combo.name,
            "cant": combo.amount,
            "mainDetail": {},
            "sideDetails": [],
         }
         let setGroupsData = []
         combo.setGroups.forEach(setGroup => {

            setGroup.groups.forEach(group => {
               //json group format
               let dataDetail = {
                  "name": group.name,
                  "external_reference": group.external_reference,
                  "isMainProduct": false,
               }

               let dataSegments = []
               group.segments.forEach(segment => {
                  let detail = {
                     "external_reference": segment.external_reference,
                     "name": segment.name,
                     "amount": segment.amount,
                  }
                  dataSegments.push(detail)
               })
               //add data segments to group
               dataDetail.condiments = dataSegments

               if (setGroup.isMainSetGroup == 1) {
                  //add data to main detail
                  dataDetail.isMainProduct = true
                  dataDetailCombo.mainDetail = dataDetail
               } else {
                  //add data to side details
                  dataDetail.price = group.price
                  dataDetail.cant = group.amount
                  dataDetail.total = group.price
                  setGroupsData.push(dataDetail)
               }
            })
            //add data side details to combo
            dataDetailCombo.sideDetails = setGroupsData
         })
         //add combo to products
         data.push(dataDetailCombo)
      })
      jsonMicrosCheck.products = data
      createCheckMicrosOrderLocal(jsonMicrosCheck, action)
   }

   //request local to create open check in micros
   const createCheckMicrosOrderLocal = async (jsonMicrosCheck, action) => {
      let token = localStorage.getItem('x-access-machine-token');
      let type = "POST"
      if (action == "update") {
         type = "PUT"
      }
      let data = {
         Ruta: `http://${jsonMicrosCheck.localMicrosServerIp}:9472/api/micros/checks?RvcRef=${jsonMicrosCheck.RvcRef}&employeeNum=${jsonMicrosCheck.employeeNum}&host_url=${jsonMicrosCheck.host_url}`,
         Type: type,
         Header: { "x-access-token": token },
         Body: jsonMicrosCheck
      }


      //console.log("DATA MICROSCHECK");
      //console.log(data);
      let micros_response;
      try {
         micros_response = await RequestLocalFetchAPI.postMicros(data);
         //console.log(micros_response);

         //We validate if the micros response is success
         if (action == "create") {
            if (micros_response.data.micros_response.PostTransactionExResponse.pTotalsResponse.OperationalResult.ErrorCode._text !== undefined && micros_response.data.micros_response.PostTransactionExResponse.pTotalsResponse.OperationalResult.ErrorCode._text === "Success") {

               //We add the data that we want to update 
               let data_to_update = {
                  micros_reference: {
                     checkNum: micros_response.data.micros_response.PostTransactionExResponse.pGuestCheck.CheckNum._text,
                     checkSeq: micros_response.data.micros_response.PostTransactionExResponse.pGuestCheck.CheckSeq._text,
                  }
               }
               //We make the update of the order 
               createPreOrder(data_to_update)
            }
         } else if (action == "update") {
            updatePreOrder()
         }
      } catch (err) {
         console.log(err);
      }
   }

   //function action print order
   let arrayPrintersTemp = []

   const getPrinter = async () => {
      try {
         const response = await PrinterFetchAPI.getPrinter(localStorage.getItem('x-access-machine-token'), machine.id);

         let arrayPrinters = response.data.printers;
         let printer_Comanda = "";
         let printer_ticket = "";
         let printer_zebra = "";
         let printer_ip = "";
         for (let i = 0; i < arrayPrinters.length; i++) {
            getCategoriesByprinter(arrayPrinters[i])
            if (arrayPrinters[i].printer_type == 'Tickets') {
               printer_ticket = arrayPrinters[i].printer_name
               printer_ip = arrayPrinters[i].ip || ""
            } else if (arrayPrinters[i].printer_type == 'Comanda') {
               printer_Comanda = arrayPrinters[i].printer_name
            } else if (arrayPrinters[i].printer_type == 'Zebra') {
               printer_zebra = arrayPrinters[i].printer_name;
            }
         }

         setPrinters(arrayPrintersTemp)
         setInfoPrinter({ printer_comanda: printer_Comanda, printer_ticket: printer_ticket, printer_zebra: printer_zebra, printer_ip: printer_ip });

      } catch (err) {
         console.log(err);
      }
   }



   const getCategoriesByprinter = async (printer) => {

      try {
         const response = await CategriesPosFetchAPI.getCategoriesByPrinters(printer.printer_id, localStorage.getItem('x-access-machine-token'))
         printer.categories = response.data.categories

      } catch (err) {
         printer.categories = []
         console.log(err);
      }
      arrayPrintersTemp.push(printer)

   }

   //print order
   const printOrder = async (id_Orden_Imprimir, transaction_code) => {
      let ip_print = "localhost"

      if (localStorage.getItem("ip_printer") != "" && localStorage.getItem("ip_printer") != undefined && localStorage.getItem("ip_printer") != null) {
         ip_print = localStorage.getItem("ip_printer")
      }

      let JsonImprimir = [{
         "type_ticket": "precuenta",
         "Printers": printers,
         "Nombre_maquina_impresora": infoPrinter.printer_ticket,
         "Nombre_cocina_impresora": infoPrinter.printer_comanda,
         "Nombre_zebra_impresora": infoPrinter.printer_zebra,
         "PRINTER_IP": infoPrinter.printer_ip,
         "Id_Orden_Imprimir": id_Orden_Imprimir,
         "token": localStorage.getItem('x-access-machine-token'),
         "transaction_code": transaction_code,
         "amount_item": shoppingCart.length,
         "imprimir_comanda": "si",
      }]

      //console.log("JSON PRINT: ", JsonImprimir);
      printOrderData(JsonImprimir);

      try {
         const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));

         if (ip_print == "localhost") {
            const response = await PrinterFetchAPI.printOrder(ip_print, JsonImprimir, response_machine.data.data.windows_ip)
         } else {
            const response = await PrinterFetchAPI.printByServerMiddle(ip_print, JsonImprimir)
         }
         //console.log(response);
      } catch (err) {
         console.log(err);
      }
   }

   // view get order to return


   const cardGetOrder = () => {
      const cardOrder = shoppingCart.map((product, index) => (
         <React.Fragment key={index}>
            {product.type == "separator" ? <>
               <div className="sp-poi-sep">
                  <span className="sp-poi-sep__label"><i className="uil uil-arrow-from-top"></i> {product.name}</span>
               </div>
            </> : <>
               <div className="sp-poi">
                  <div className="sp-poi__top">
                     <img
                        className="sp-poi__thumb"
                        loading="lazy"
                        src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage}
                        width="42" height="42"
                        alt={product.name}
                     />
                     <div className="sp-poi__info">
                        <div className="sp-poi__name">{product.name}</div>
                     </div>
                     <div className="sp-poi__price" translate="no">$ {product.price.toFixed(2)}</div>
                  </div>

                  <details className="sp-poi__details" open>
                     <summary className="sp-poi__summary">
                        <i className="uil uil-info-circle"></i> Detalles
                     </summary>
                     <ul className="sp-poi__seglist">
                        {product.segments.map((item, idx) => (
                           <li key={idx} className="sp-poi__seg">
                              <span className="sp-poi__seg-name">{item.segment_name}: {item.name}</span>
                              <span className="sp-poi__seg-price" translate="no">${parseFloat(item.price).toFixed(2)}</span>
                           </li>
                        ))}
                     </ul>
                  </details>
               </div>
            </>}
         </React.Fragment>
      ));
      return (cardOrder)
   }

   // view get order to return
   const cardGetOrderCombo = () => {
      const cardOrder = shoppingCartCombos.map((product) => (
         <>

            <div >
               <div className="d-flex rounded m-1 bg-white mt-1 card-pos">
                  <div className="flex-shrink-0">
                     <img className='m-1 rounded  bg-light border ' loading='lazy' src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage} width="42" height="42" />
                  </div>
                  <div className="flex-grow-1 m-1">
                     <div className="d-flex bd-highlight">
                        <div className="bd-highlight title-product-cart mt-1 text-dark fw-bold">
                           {product.name}
                        </div>
                        <div className="ms-auto px-2 bd-highlight text-price-cart" translate='no'>
                           $ {product.price.toFixed(2)}
                        </div>
                     </div>

                     <div className={``}>
                        {product.setGroups.map((setGroup) => (
                           <div className="d-flex justify-content-between" key={setGroup.set_id}>
                              <details close >
                                 <summary className=''>
                                    <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap m-1 '>
                                       <i className="uil uil-info-circle  px-1 "> {setGroup.name}</i>
                                    </span>
                                 </summary>
                                 {setGroup.groups.map((group) => (<>
                                    {cardGroup(group)}
                                 </>))}
                              </details>
                           </div>))}
                     </div>
                  </div>
               </div>
            </div>
         </>
      ));
      return (cardOrder)
   }


   // update pre order
   const updatePreOrder = async (micros) => {
      if (stateRequest == false) {
         setStateRequest(true)
         let token = localStorage.getItem('x-access-machine-token');
         //console.log(shoppingCart);
         let json = {
            "client_name": name,
            "localizador": "00",
            "table_name": tableNumber,
            "ruc": ruc,
            "dv": dv,
            "is_discount_notification": false,
            "_id": dataPreOrder._id,
            "order_type": checkDeliveryOrder,
            "groups": shoppingCart,
            "combos": shoppingCartCombos,
            "discounts": dataDicountApply,
            "taxes": taxesArrayAll,
            "discount": discount,
            "is_authorized": true,
            "total": total,
            "tax": tax,
            "subtotal": subtotal,
         }

         if (micros != undefined) { json.micros_reference = micros.micros_reference }

         try {
            const response = await PreOrderFetchAPI.updateOrderTempPreOrder(json, token)
            setStateRequest(false)
            //console.log(response);
            if (micros != undefined) {

            } else {
               printOrder(response.data._id, response.data.code)
               setShow(false)
               let message = "Precuenta actualizada con exito."
               let title = "Operacion exitosa"
               let icon = "success"
               setPageLoader(1)
               ErrorAlert(message, title, icon)
            }


         } catch (err) {
            setStateRequest(false)
            let message = ""
            let title = "Ocurrio un error"
            let icon = "error"
            ErrorAlert(message, title, icon)

         }

      } else {
         console.log("Ya se esta procesando la orden");
      }
   }

   const handlerChangeDataOrder = () => {


      if (dataPreOrder.pre_Order == true) {
         getPreOrderByid()
      }
      ErrorAlert("", "Nombre guardado", "success")
   }




   //function to compare data micros and update
   const handlerComparativeNewData = () => {
      let preOrderComparativeOld = JSON.parse(localStorage.getItem('preOrderComparativeOld'))
      let OrderGroupsOld = preOrderComparativeOld.groups
      let OrderCombosOld = preOrderComparativeOld.combos
      let newGroups = []
      let newCombos = []

      //comparative groups
      shoppingCart.forEach(group => {
         let groupOld = OrderGroupsOld.find(item => item.group_id == group.group_id && item.segments_string == group.segments_string)

         if (groupOld != undefined) {
            if (groupOld.amount != group.amount) {
               let newGroup = groupOld
               newGroup.amount = (group.amount - groupOld.amount)
               newGroup.cantidadItem = (group.amount - groupOld.amount)
               newGroups.push(newGroup)
            }
         } else {
            newGroups.push(group)
         }
      });

      //Add string data to compare
      shoppingCartCombos.forEach(combo => {
         let stringdata = combo.combo_id + "";
         combo.setGroups.forEach(setGroup => {
            stringdata += setGroup.set_id;
            setGroup.groups.forEach(group => {
               stringdata += group.group_id;
               group.segments.forEach(segment => {
                  stringdata += segment.segment_id + segment.item.item_id;
               });
            });
         });
         combo.combo_string = stringdata;
      });

      //Add string data to compare
      OrderCombosOld.forEach(comboOld => {
         let stringdataOld = comboOld.combo_id + "";
         comboOld.setGroups.forEach(setGroup => {
            stringdataOld += setGroup.set_id;
            setGroup.groups.forEach(group => {
               stringdataOld += group.group_id;
               group.segments.forEach(segment => {
                  stringdataOld += segment.segment_id + segment.item.item_id;
               });
            });
         });
         comboOld.combo_string = stringdataOld;
      });

      //==========================================
      //Comparative combos
      shoppingCartCombos.forEach(combo => {
         let comboOld = OrderCombosOld.find(comboOld => comboOld.combo_id == combo.combo_id && comboOld.combo_string == combo.combo_string)

         if (comboOld != undefined) {
            if (comboOld.amount != combo.amount) {
               let newCombo = comboOld
               newCombo.amount = (combo.amount - comboOld.amount)
               newCombo.cantidadItem = (combo.amount - comboOld.amount)
               newCombos.push(newCombo)
            }
         } else {
            newCombos.push(combo)
         }
      });

      formatDataMicrosCheck(newGroups, newCombos, "update")
   }



   return (
      <>


         {/* <article className='col-12 col-xl-6 col-lg-6 col-md-6 my-1 list-pre-orders-inputs-pays' key={"eco01"} onClick={() => (setShow(true), getPrinter(), getPreOrderByid())}>
            <div
               className="list-group-item-check-pay "
            />

            <label className="list-group-item rounded-3 mb-0 fw-bold text-truncate bg-white rounded-2 p-1 shadow-sm"
               htmlFor={"Eco" + "payment"}
            >
               <div className="d-flex align-items-center gap-3 py-1 rounded" >
                  <img src={payOnline}
                     alt="Product" width="80" height="80" className="rounded border flex-shrink-0" />
                  <div className="d-flex gap-2 justify-content-around py-2">
                     <span className="mb-3 text-wrap">
                        Pago en linea
                     </span>
                  </div>
               </div>
               <span class="badge bg-secondary-subtle text-secondary-emphasis rounded-pill bottom-0 end-0 position-absolute m-1">
                  eCommerce
               </span>
            </label>
         </article> */}


         <div className="sp-pg__method sp-pg__method--wide" key={"eco01"}
            onClick={() => (setShow(true), getPrinter(), getPreOrderByid())}>
            <div className="sp-pg__methodcard sp-pg__methodcard--wide">
               <span className="sp-pg__methodimg sp-pg__methodimg--wide">
                  <img src={payOnline} alt="Pago en linea" loading="lazy" />
               </span>
               <span className="sp-pg__methodwrap">
                  <span className="sp-pg__methodname">Pago en linea</span>
                  <span className="sp-pg__methodbadge">eCommerce</span>
               </span>
            </div>
         </div>

         <Modal
            show={show}
            size="xl"
            centered
            onHide={() => setShow(false)}
            dialogClassName="sp-oo-dialog"
            contentClassName="sp-oo-content"
         >
            <Modal.Body className="sp-oo">

               {/* Header */}
               <div className="sp-oo__head">
                  <div className="sp-oo__badge"><i className="uil uil-shopping-bag"></i></div>
                  <h2 className="sp-oo__title">
                     {dataPreOrder.pre_Order && dataPreOrder.pre_Order == true ? <>Actualizar orden en linea</> : <>Crear orden en linea</>}
                  </h2>
                  <button className="sp-oo__x" type="button" aria-label="Cerrar" onClick={() => setShow(false)}>
                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                  </button>
               </div>

               {/* Cuerpo: 2 columnas */}
               <div className="sp-oo__grid">

                  {/* Izquierda: cliente + totales */}
                  <div className="sp-oo__col sp-oo__col--form">
                     <span className="sp-oo__sectlabel">Datos de Cliente</span>
                     <ModalClientProfile dataClientSelected={dataClientSelected} setdataClientSelected={setdataClientSelected} addressNowLocation={addressNowLocation} setAddressNowLocation={setAddressNowLocation} parthner_order={parthner_order}></ModalClientProfile>

                     {eventsAndDates()}

                     <div className="sp-oo__totals-wrap">
                        <span className="sp-oo__sectlabel">Totales</span>
                        <div className="sp-oo__totals">
                           <div className="sp-oo__tcard">
                              <strong>Descuento</strong>
                              <span translate="no">$ {discount.toFixed(2)}</span>
                           </div>
                           <div className="sp-oo__tcard">
                              <strong>Impuestos</strong>
                              <span translate="no">$ {tax.toFixed(2)}</span>
                           </div>
                           <div className="sp-oo__tcard">
                              <strong>Subtotal</strong>
                              <span translate="no">$ {subtotal.toFixed(2)}</span>
                           </div>
                           <div className="sp-oo__tcard sp-oo__tcard--total">
                              <strong>Total</strong> <small>(+Impuestos)</small>
                              <span translate="no">$ {total.toFixed(2)}</span>
                           </div>
                        </div>
                     </div>
                  </div>

                  {/* Derecha: productos */}
                  <div className="sp-oo__col sp-oo__col--summary">
                     <div className="sp-oo__panel">
                        <span className="sp-oo__sectlabel">Lista de Productos de Orden</span>
                        <div className="sp-oo__items">
                           {cardGetOrder()}
                           {cardGetOrderCombo()}
                        </div>
                     </div>
                  </div>
               </div>

               {/* Footer fijo */}
               <div className="sp-oo__foot">
                  <button className="sp-oo__btn sp-oo__btn--cancel" onClick={() => (setShow(false))}>
                     <i className="uil uil-times-circle"></i> Cancelar
                  </button>

                  {dataPreOrder.pre_Order && dataPreOrder.pre_Order == true ? <>
                     <button className="sp-oo__btn sp-oo__btn--info" onClick={async () => (handlerUpdateValidation())}>
                        <i className="uil uil-check"></i> Actualizar orden
                     </button>
                  </> : <>
                     <button className="sp-oo__btn sp-oo__btn--ok" onClick={() => handlercreateValidation()}>
                        <i className="uil uil-check"></i> Crear orden
                     </button>
                  </>}
               </div>

            </Modal.Body>
         </Modal>


         <ModalSendLinkPayment sendLinkPayment={sendLinkPayment} setSendLinkPayment={setSendLinkPayment} PreOrderDataCallCenter={PreOrderDataCallCenter} dataClientSelected={dataClientSelected} dataOrder={dataOrder} domain={domain} buttonNewOrder={true} />



      </>
   )
}

export default ModalCallCenter